module.exports = __webpack_public_path__ + "img/aka.5f5c286c.svg";